import React, { Component } from "react"

import {
  Container,
  Card,
  Button,
  Item,
  Image,
} from "semantic-ui-react"
import { NavLink } from "react-router-dom"

import classes from "./Style.module.css"

class Signup extends Component {
  render() {
    return (
      <Container text style={{ marginTop: "7em" }}>
        <Card.Group centered>
          <Card raised>
            <Card.Content>
              <Card.Header>Sign up</Card.Header>
            </Card.Content>
            <Card.Content>
              <Item.Group>
                <Item>
                  <Button as="a" href="/auth/google" basic fluid icon="/g-logo.png">
                    <Image src="/g-logo.png" width={18} height={18} floated="left" />
                    Sign up with Google
                  </Button>
                </Item>
                <Item>
                  <Button as="a" href="/auth/facebook" basic fluid >
                    <Image src="/f-logo.png" width={18} height={18} floated="left" />
                    Sign up with Facebook
                  </Button>
                </Item>
              </Item.Group>
              {/* <Divider horizontal>Or</Divider>
              <Label color="orange" pointing="below">
                Coming soon...
              </Label>
              <Input disabled fluid icon placeholder='E-Mail'>
                <input />
                <Icon name='at' />
              </Input> */}
              <Item.Group>
                {/* <Item>
                  <Button disabled primary fluid>Sign up with E-Mail</Button>
                </Item> */}
                <p className={classes.text}>
                  By signing up with Google or Facebook you accept tascaly's
                  <NavLink to="/terms">
                    Terms and Conditions
                  </NavLink>
                  {" "}and{" "}
                  <NavLink to="/privacy">
                    Privacy Policy
                  </NavLink>.
                </p>
              </Item.Group>
            </Card.Content>
            <Card.Content textAlign="center">
              <p className={classes.switch}>
                Already have an account?{" "}
                <NavLink to="/login">
                  Log in
                </NavLink>
              </p>
            </Card.Content>
          </Card>
        </Card.Group>
      </Container>
    )
  }
}

export default Signup